(function ($) {
    $(document).ready(function () {
        let referrer_in;
        let popup_node = $('.btn-back-more').data('node');

        if(document.referrer.indexOf('trshealthcare.com') >= 0 || document.referrer.indexOf('trshealthcadev.wpengine.com') >= 0 || document.referrer.indexOf('localhost:10003') >= 0){
            referrer_in = true;
            $('.btn-back').show();
            $('.btn-back-more').hide();
        }else{
            referrer_in = false;
            $('.btn-back').hide();
            $('.btn-back-more').show();
        }
        $('.btn-back a').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            if(referrer_in){
                if(window.history.length <= 1){
                    window.location.href = document.referrer;
                }else{
                    window.history.back();
                }
            }else{
                window.location.href = '/careers/find-a-job/';
            }
        });

        $('.btn-back-more a').click(function (e){
            $('.fl-node-'+popup_node+'.fl-button-lightbox-content').parents('.mfp-wrap').eq(0).removeAttr("tabindex");
        })

    });
})(jQuery);